import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-699f2a2c")

_pushScopeId("data-v-699f2a2c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Profilo")
const _hoisted_2 = { class: "page_content" }
const _hoisted_3 = {
  key: 0,
  class: "modal_qrcode"
}
const _hoisted_4 = { class: "input_container qr_generate_container" }
const _hoisted_5 = { class: "container_user_info" }
const _hoisted_6 = { class: "user_avatar_container" }
const _hoisted_7 = { class: "username" }
const _hoisted_8 = { class: "single_user_info" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Email", -1)
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "single_user_info" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Codice fiscale", -1)
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "single_user_info" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Cellulare", -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "single_user_info" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Data di nascita", -1)
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "single_user_info" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Luogo di nascita", -1)
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "single_user_info" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Tipologia utente", -1)
const _hoisted_25 = { class: "value" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "single_user_info" }, [
  /*#__PURE__*/_createVNode("div", { class: "title" }, "Versione applicazione"),
  /*#__PURE__*/_createVNode("div", { class: "value" }, "2.7")
], -1)
const _hoisted_27 = { class: "profile_actions ion-margin-top" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_QRCodeVue3 = _resolveComponent("QRCodeVue3")
  const _component_ion_avatar = _resolveComponent("ion-avatar")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start",
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_Transition, { name: "fade-transition" }, {
              default: _withId(() => [
                ($setup.showQrImage)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode("div", _hoisted_4, [
                        _createVNode(_component_QRCodeVue3, {
                          value: $setup.randomString,
                          width: 250,
                          height: 250,
                          qrOptions: { typeNumber: '0', mode: 'Byte', errorCorrectionLevel: 'Q' },
                          imageOptions: { hideBackgroundDots: true, imageSize: 0.0, margin: 0 },
                          dotsOptions: { type: 'square', color: '#000000' },
                          cornersSquareOptions: { type: 'square', color: '#000000' }
                        }, null, 8, ["value", "imageOptions"]),
                        _createVNode("div", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.closeQrImage())),
                          class: "btn_close_qrcode"
                        }, "Chiudi")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_ion_avatar, null, {
                  default: _withId(() => [
                    _createVNode("img", {
                      src: $setup.setImage($setup.user)
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_7, _toDisplayString($setup.user.dipendenti_nome) + " " + _toDisplayString($setup.user.dipendenti_cognome), 1)
              ]),
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, _toDisplayString($setup.user.users_email), 1)
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode("div", _hoisted_13, _toDisplayString($setup.user.dipendenti_codice_fiscale || "-"), 1)
              ]),
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("div", _hoisted_16, _toDisplayString($setup.user.dipendenti_cellulare || "-"), 1)
              ]),
              _createVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode("div", _hoisted_19, _toDisplayString($setup.dateFormat($setup.user.dipendenti_data_nascita) || "-"), 1)
              ]),
              _createVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode("div", _hoisted_22, _toDisplayString($setup.user.dipendenti_luogo_nascita || "-"), 1)
              ]),
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("div", _hoisted_25, _toDisplayString($setup.user.users_type_value || "-"), 1)
              ]),
              _hoisted_26
            ]),
            _createVNode("div", _hoisted_27, [
              _createVNode("div", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openQrImage && $setup.openQrImage(...args))),
                class: "btn_force_update"
              }, " Mostra codice QR "),
              _createVNode("div", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.updateApp && $setup.updateApp(...args))),
                class: "btn_force_update"
              }, " Forza aggiornamento "),
              _createVNode("div", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.logOut && $setup.logOut(...args))),
                class: "btn_logout"
              }, "Logout")
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})